import React from 'react';
import { Permissions, TabInfo } from '../../models';

export class CompetitionAdminTab extends React.Component {
	static register = { name: "CompetitionAdminTab" };
	static wire = ["fire", "Events", "EventBus", "Server", "CompetitionProperties", "Competition", "Footers"];
	static tabInfo = new TabInfo("Inställningar", "admin", 204, Permissions.Admin);

	constructor(props) {
		super(props);
		this.state = {};
		this.EventBus.manageEvents(this);
		this.subscribe(this.Events.competitionUpdated, () => {
			this.setState({});
			this.fire(this.Events.changeTitle, `Inställningar för ${this.Competition.name}`);
		});
	}

	componentDidMount() {
		this.fire(this.Events.changeTitle, `Inställningar för ${this.Competition.name}`);
	}

	render() {
		return <div className="content">
			<button className={this.Competition.dirty ? "button" : "button disabled"} onClick={() => this.Competition.saveCompetition()}>Spara</button>
			<this.CompetitionProperties />
		</div>;
	}
}


// WEBPACK FOOTER //
// ./src/views/competitiontabs/CompetitionAdminTab.js